import actionCreatorFactory from "typescript-fsa"

const actionCreator = actionCreatorFactory()
// ReduxのUUIDstate更新アクション
export const uuidActions = {
  updateUUID: actionCreator<string>("ACTIONS_UPDATE_UUID")
}

export default uuidActions
